import React, {useEffect} from "react";
import globalMasehtot from "../../masehtot.json";
import Spinner from "../../../spinner";

const PrintDapim = ({siumStatus, usersList, pagesWereTaken, pagesWereLearned, sium, back}) => {

    const logoList = {
        'hamesh-esre': '/hameshEsre.png',
        'yacahdBeorcha': '/yacahdBeorcha.png',
        'mehinotToraniot': '/mehinotToraniot.png',
        'chabad': '/chabad.png',
        'uriel': '/uriel.png'
    };

    useEffect(() => {
        if (!siumStatus) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
            window.print();
        }, 1500);
    }, [siumStatus]);

    if (!sium || !sium.kehilaName || !globalMasehtot.allMasehtot || !siumStatus) {
        return (<Spinner/>);
    }

    const today = new Date();
    const endD = sium.endSium?.toDate();
    const daysNum = endD ? Math.round((endD - today) / (24 * 60 * 60 * 1000)) : null;
    const logoImg = sium.logo && logoList[sium.logo] ? logoList[sium.logo] : null;

    const takenPercent = Math.floor((pagesWereTaken / sium.pagesCounter) * 100);
    const learnedPercent = Math.floor((pagesWereLearned / sium.pagesCounter) * 100);

    // Process masehtot data with page counts
    const masehtotData = Object.entries(siumStatus)
        .filter(([key]) => key !== 'totalPages' && key !== 'masehetIndex' && key !== 'isMishna')
        .sort(([, a], [, b]) => (a.masehetIndex || 0) - (b.masehetIndex || 0))
        .map(([masehetKey, masehet]) => {
            const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
            if (!currentMasehet) return null;

            const totalPages = masehet.totalPages || 0;
            // takenPages and learnedPages are numbers, not arrays
            const takenPages = typeof masehet.takenPages === 'number' ? masehet.takenPages : 0;
            const learnedPages = typeof masehet.learnedPages === 'number' ? masehet.learnedPages : 0;
            const allTaken = totalPages > 0 && totalPages === takenPages;
            const allLearned = totalPages > 0 && totalPages === learnedPages;

            // Get unique learners for this masehet from usersList
            const learnerNames = [];
            if (usersList) {
                Object.entries(usersList).forEach(([, user]) => {
                    const userMasehtot = Object.keys(user.pages || {}).map(key => key.split('-')[0]);
                    if (userMasehtot.includes(masehetKey)) {
                        learnerNames.push(user.name);
                    }
                });
            }

            return {
                key: masehetKey,
                name: currentMasehet.name,
                isMishna: currentMasehet.isMishna,
                totalPages,
                takenPages,
                learnedPages,
                allTaken,
                allLearned,
                learners: [...new Set(learnerNames)],
                percent: totalPages > 0 ? Math.floor((learnedPages / totalPages) * 100) : 0
            };
        }).filter(Boolean);

    return (
        <div className="print-page">
            {/* No-print back button */}
            <div className="no-print print-back-btn">
                <button className="btn sium-button return-button" onClick={() => back(false)}>חזור</button>
            </div>

            {/* Header */}
            <div className="print-header">
                <div className="print-header-right">
                    <span className="print-basad">בס"ד</span>
                </div>
                <div className="print-header-center">
                    <h1 className="print-title">סיום הש"ס של {sium.kehilaName}</h1>
                    {sium.nishmat && <p className="print-nishmat">{sium.nishmat}</p>}
                </div>
                <div className="print-header-left">
                    {logoImg && <img src={logoImg} alt="logo" className="print-logo-img" />}
                </div>
            </div>

            {/* Progress Summary */}
            <div className="print-summary">
                <div className="print-summary-item">
                    <span className="print-summary-label">נלקחו:</span>
                    <span className="print-summary-value">{takenPercent}%</span>
                    <div className="print-progress-bar">
                        <div className="print-progress-fill taken" style={{width: `${takenPercent}%`}}></div>
                    </div>
                </div>
                <div className="print-summary-item">
                    <span className="print-summary-label">נלמדו:</span>
                    <span className="print-summary-value">{learnedPercent}%</span>
                    <div className="print-progress-bar">
                        <div className="print-progress-fill learned" style={{width: `${learnedPercent}%`}}></div>
                    </div>
                </div>
                {daysNum !== null && daysNum > 0 && (
                    <div className="print-summary-item days">
                        <span>נותרו {daysNum} ימים</span>
                    </div>
                )}
            </div>

            {/* Masehtot Grid */}
            <div className="print-masehtot-grid">
                {masehtotData.map((masehet) => (
                    <div
                        key={masehet.key}
                        className={`print-masehet-item ${masehet.allLearned ? 'completed' : masehet.allTaken ? 'taken' : masehet.takenPages > 0 ? 'partial' : 'empty'}`}
                    >
                        <div className="print-masehet-header">
                            <span className="print-masehet-name">{masehet.name}</span>
                            {masehet.isMishna && <span className="print-mishna-badge">מ</span>}
                            <span className="print-masehet-status">
                                {masehet.allLearned ? '✓' : `${masehet.learnedPages}/${masehet.totalPages}`}
                            </span>
                        </div>
                        {masehet.learners.length > 0 && (
                            <div className="print-masehet-learners">
                                {masehet.learners.slice(0, 3).join(', ')}
                                {masehet.learners.length > 3 && ` (+${masehet.learners.length - 3})`}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Legend */}
            <div className="print-legend">
                <div className="print-legend-item">
                    <span className="print-legend-box completed"></span>
                    <span>נלמד</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-legend-box taken"></span>
                    <span>נלקח</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-legend-box partial"></span>
                    <span>חלקי</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-legend-box empty"></span>
                    <span>פנוי</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-mishna-badge">מ</span>
                    <span>משנה</span>
                </div>
            </div>

            {/* Learners Summary Table */}
            {usersList && Object.keys(usersList).length > 0 && (
                <div className="print-learners-section">
                    <h3 className="print-section-title">רשימת לומדים ({Object.keys(usersList).length})</h3>
                    <div className="print-learners-table">
                        {Object.entries(usersList)
                            .sort(([, a], [, b]) => (a.name || '').localeCompare(b.name || '', 'he'))
                            .map(([userId, user]) => {
                                const learnedCount = Object.values(user.pages || {}).filter(v => v === true).length;
                                const totalCount = Object.keys(user.pages || {}).length;
                                const userPercent = totalCount > 0 ? Math.floor((learnedCount / totalCount) * 100) : 0;
                                const isComplete = learnedCount === totalCount && totalCount > 0;

                                return (
                                    <div key={userId} className={`print-learner-row ${isComplete ? 'complete' : ''}`}>
                                        <span className="print-learner-name">{user.name}</span>
                                        <span className="print-learner-progress">
                                            {isComplete ? '✓' : `${userPercent}%`}
                                        </span>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            )}

            {/* Footer */}
            <div className="print-footer">
                <span>© כל הזכויות שמורות לאתר סיום הש"ס | siumshas.co.il</span>
            </div>
        </div>
    );
};

export default PrintDapim;
